var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdateTechnological(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "contenitore",
    width: 70,
    height: 70,
    transform: "translate(283.702 633)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "organizzazione_del_lavoro",
    "data-name": "organizzazione del lavoro",
    transform: "translate(-102.702 -299)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppo_di_maschere_29",
    "data-name": "Gruppo di maschere 29",
    transform: "translate(-181 -334)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "fondo",
    d: "M25.57,74.016C2.232,86.383-.045,34.5,3.708,27.4c12.148-16.948,24.552,1.447,33.886-6.18C51.945,9.483,67.032,9.035,70.109,23.826s-.2,48.362-20.981,44.858C34.375,66.2,25.57,74.016,25.57,74.016Z",
    transform: "translate(277.141 629.598) rotate(-8)",
    fill: "#dedbdb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "aggiornamento_tecnologico",
    "data-name": "aggiornamento tecnologico",
    transform: "translate(24761.701 -18358)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1321",
    "data-name": "Path 1321",
    d: "M609.782,78.326h-.363V68.373a5.76,5.76,0,0,0-5.76-5.76H582.573a5.76,5.76,0,0,0-5.76,5.76v54.6a5.76,5.76,0,0,0,5.76,5.76h21.086a5.76,5.76,0,0,0,5.76-5.76V85.41h.363Z",
    transform: "translate(-25034.484 18930.418)",
    fill: "#b8b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1322",
    "data-name": "Path 1322",
    d: "M619.79,79.106h-2.752a2.044,2.044,0,0,1-1.892,2.816h-12.08a2.044,2.044,0,0,1-1.892-2.816H598.6a4.3,4.3,0,0,0-4.3,4.3v54.52a4.3,4.3,0,0,0,4.3,4.3H619.79a4.3,4.3,0,0,0,4.3-4.3h0V83.408a4.3,4.3,0,0,0-4.3-4.3Z",
    transform: "translate(-25050.385 18915.424)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M644.04,477.955h-25.4a.471.471,0,0,1-.47-.47v-6.3a.471.471,0,0,1,.47-.47h25.4a.471.471,0,0,1,.47.47v6.3A.471.471,0,0,1,644.04,477.955Zm-25.4-7.054a.283.283,0,0,0-.282.282v6.3a.283.283,0,0,0,.282.282h25.4a.283.283,0,0,0,.282-.282v-6.3a.283.283,0,0,0-.282-.282Z",
    transform: "translate(-25072.08 18559.395)",
    fill: "#03518c",
    stroke: "#03518c",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 1.976,
    cy: 1.976,
    r: 1.976,
    transform: "translate(-24452.127 19031.754)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M706.521,496.073a.329.329,0,1,0,0,.659h15.525a.329.329,0,1,0,.011-.659H706.522Z",
    transform: "translate(-25152.109 18536.34)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M706.521,517.821a.329.329,0,0,0,0,.659h15.525a.329.329,0,0,0,.011-.659H706.522Z",
    transform: "translate(-25152.109 18516.566)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M644.04,593.945h-25.4a.471.471,0,0,1-.47-.47v-6.3a.471.471,0,0,1,.47-.47h25.4a.471.471,0,0,1,.47.47v6.3A.471.471,0,0,1,644.04,593.945Zm-25.4-7.054a.283.283,0,0,0-.282.282v6.3a.283.283,0,0,0,.282.282h25.4a.283.283,0,0,0,.282-.282v-6.3a.283.283,0,0,0-.282-.282Z",
    transform: "translate(-25072.08 18453.943)",
    fill: "#03518c",
    stroke: "#03518c",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 1.976,
    cy: 1.976,
    r: 1.976,
    transform: "translate(-24452.127 19042.291)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M706.521,612.063a.329.329,0,0,0,0,.659h15.525a.329.329,0,1,0,.011-.659H706.522Z",
    transform: "translate(-25152.109 18430.887)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M706.521,633.811a.329.329,0,0,0,0,.659h15.525a.329.329,0,0,0,.011-.659H706.522Z",
    transform: "translate(-25152.109 18411.115)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M667.823,227.6a8.935,8.935,0,0,1-8.938-8.931v-.007c0-.019,0-.038,0-.057a8.938,8.938,0,1,1,8.938,9h0Zm0-17.689a8.769,8.769,0,0,0-8.749,8.7c0,.02,0,.036,0,.051a8.751,8.751,0,1,0,8.751-8.75Z",
    transform: "translate(-25109.1 18796.67)",
    fill: "#03518c",
    stroke: "#03518c",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_711",
    "data-name": "Path 711",
    d: "M587.135,508.365h-9.05a.182.182,0,0,1-.034,0l4.28-7.414a.3.3,0,0,1,.522,0l2.873,4.975.138.238Z",
    transform: "translate(-25023.779 18510.754)",
    fill: "#03518c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1265",
    "data-name": "Path 1265",
    d: "M380.877,573.178a2.05,2.05,0,0,1-.042.412,3.061,3.061,0,0,1-2.39,0,2.049,2.049,0,0,1-.041-.412,1.609,1.609,0,0,1,.87-1.529.945.945,0,1,1,.733,0A1.609,1.609,0,0,1,380.877,573.178Z",
    transform: "translate(-24795.172 18435.361)",
    fill: "#03518c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1362",
    "data-name": "Path 1362",
    d: "M516.425,138.016l7.461,7.52h3.522v.118h-3.572l-.017-.018-7.478-7.537Z",
    transform: "translate(-24982.738 18888.711)",
    fill: "#757575",
    stroke: "#757575",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45-2",
    "data-name": "Path 45",
    d: "M662.884,217.726a4,4,0,0,1-4-4V213.7a4,4,0,1,1,4,4.026Zm0-7.916a3.924,3.924,0,0,0-3.915,3.893v.023a3.916,3.916,0,1,0,3.916-3.916Z",
    transform: "translate(-25131.871 18809.98)",
    fill: "#03518c",
    stroke: "#03518c",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1363",
    "data-name": "Path 1363",
    d: "M516.425,138.016l7.461,7.52h3.522v.118h-3.572l-.017-.018-7.478-7.537Z",
    transform: "translate(-24982.738 18899.902)",
    fill: "#757575",
    stroke: "#757575",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45-3",
    "data-name": "Path 45",
    d: "M662.884,209.726a4,4,0,0,0-4,4v.029a4,4,0,1,0,4-4.026h0Zm0,7.916a3.924,3.924,0,0,1-3.915-3.893v-.023a3.916,3.916,0,1,1,3.916,3.916Z",
    transform: "translate(-25131.871 18821.088)",
    fill: "#03518c",
    stroke: "#03518c",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3215",
    "data-name": "Raggruppa 3215",
    transform: "translate(0 -1.727)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    width: 2.307,
    height: 0.341,
    transform: "translate(-24467.791 19025.127) rotate(90)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    width: 3.999,
    height: 0.341,
    transform: "translate(-24468.611 19023.434) rotate(90)",
    fill: "#03518c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38",
    "data-name": "Rectangle 38",
    width: 3.002,
    height: 0.341,
    transform: "translate(-24469.434 19024.432) rotate(90)",
    fill: "#03518c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3216",
    "data-name": "Raggruppa 3216",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_193",
    "data-name": "Ellipse 193",
    cx: 0.523,
    cy: 0.523,
    r: 0.523,
    transform: "translate(-24470.15 19035.66)",
    fill: "#03518c",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_194",
    "data-name": "Ellipse 194",
    cx: 0.523,
    cy: 0.523,
    r: 0.523,
    transform: "translate(-24467.195 19035.66)",
    fill: "#03518c",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_195",
    "data-name": "Ellipse 195",
    cx: 0.523,
    cy: 0.523,
    r: 0.523,
    transform: "translate(-24468.674 19035.66)",
    fill: "#03518c",
    opacity: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_944",
    "data-name": "Path 944",
    d: "M306.891,657.226H237.073a.091.091,0,1,1,0-.182h69.818a.091.091,0,1,1,0,.182Z",
    transform: "translate(-24710.162 18401.926)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1414",
    "data-name": "Path 1414",
    d: "M527.323,138.016l-7.461,7.52H516.34v.118h3.572l.017-.018,7.478-7.537Z",
    transform: "translate(-24946.576 18869.682)",
    fill: "#757575",
    stroke: "#707070",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45-4",
    "data-name": "Path 45",
    d: "M662.884,217.726a4,4,0,0,1-4-4V213.7a4,4,0,1,1,4,4.026Zm0-7.916a3.924,3.924,0,0,0-3.915,3.893v.023a3.916,3.916,0,1,0,3.916-3.916Z",
    transform: "translate(-25078.416 18793.467)",
    fill: "#03518c",
    stroke: "#03518c",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateTechnological);
export default __webpack_public_path__ + "static/media/update_technological.ecb44c935425f54cd7600a1584541890.svg";
export { ForwardRef as ReactComponent };